import {Product} from '../models/product';
export const ADD_TO_BASKET: string = 'ADD_TO_BASKET';
export const REMOVE_FROM_BASKET: string = 'REMOVE_FROM_BASKET';

export const addProductToBasket = (product: Product) => {
    return {
        type: ADD_TO_BASKET,
        payload: {product : product}
    };
};

export const removeProductFromBasket = (productIndex: number) => {
    return {
        type: REMOVE_FROM_BASKET,
        payload: {productIndex: productIndex}
    };
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/basket.action.ts